<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    title="跟进"
    :footer-hide="true"
    width="630"
    class="my-modal top p-b"
  >
    <div class="follow-up-container">
      <div class="fee-status">
        <Form ref="form" :model="form" :label-width="110" class="modal-form" :rules="ruleInline">
          <FormItem label="续保状态">
            <RadioGroup v-model="form.payState" @on-change="changePayState">  
              <Radio :label="2">续保成功</Radio>
              <Radio :label="3">续保失败</Radio>
              <Radio :label="1">待续保</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="form.payState == 2" prop="newPolicyNo" label="新保单号">
            <Input v-model="form.newPolicyNo" :disabled='form.renewalSource == 1' placeholder="请输入新保单号"/>
          </FormItem>

          <FormItem key="renewalSource" v-if="form.payState == 2" prop="renewalSource" :rules="$units.formRule.required(`请选择续保方式`)" style="margin-top:15px;">
            <template #label>
              <span>续保方式</span>
              <Poptip trigger="hover" transfer transfer-class-name="my-poptip left3">
                <template #content>
                  <p>原单续保：续保后保单号不变</p>
                  <p>重投：不可续保的产品，重新投保后，生成新保单、且重新计算等待期</p>
                  <p>新单：原保单到期后，续保产生新保单，无等待期</p>
                </template>
                <Icon type="ios-help-circle-outline" />
              </Poptip>
            </template>
            <RadioGroup v-model="form.renewalSource" @on-change='changeRenew'>
              <Radio style="margin-right:20px;" label="1">原单续保</Radio>
              <Radio style="margin-right:20px;" label="3">重投（非续保）</Radio>
              <Radio style="margin-right:20px;" label="2">新单</Radio>              
              <!-- <Radio style="margin-right:20px;" label="4">转新产品</Radio> -->
            </RadioGroup>
          </FormItem>

          <FormItem prop="serverEndDate" label="实际续保日期" v-if="form.payState == 2" style="margin-top:22px;">
            <DatePicker
              type="date"
              split-panels
              transfer
              v-model="form.serverEndDate"
              placeholder="请选择"
            ></DatePicker>
          </FormItem>

          <FormItem 
            v-if="form.payState == 3 || form.payState == 1" 
            prop="serviceStateDetail" 
            :key="form.payState == 3?'error':'other'" 
            :label="form.payState == 3?'失败类型':'其他类型'" 
            :rules="$units.formRule.required(`请选择${form.payState == 3?'失败':'其他'}类型`)"
            style="margin-bottom:30px;"
          >
            <div class="failure-type">
              <div 
                class="failure-btn"
                :class="{'active':item.value == form.serviceStateDetail}" 
                v-for="item in failureType" 
                @click="selectedFailType(item)" 
                :key="item.value"
              >
                {{ item.label }}
              </div>
            </div>
          </FormItem>          

          <FormItem key="beizhu1" prop="serviceContent" label="备注" v-if="form.payState == 3" :rules="$units.formRule.required('请填写失败原因')">
            <Input v-model="form.serviceContent" placeholder="请填写续保失败原因" maxlength="50" show-word-limit type="textarea"/>
          </FormItem>

          <FormItem key="beizhu2" label="备注" v-if="form.payState == 1" prop="serviceContent">
            <Input v-model="form.serviceContent" placeholder="请填写备注" maxlength="50" show-word-limit type="textarea"/>
          </FormItem>
        </Form>
      </div>

      <div class="action-buttom">
        <div class="buttom-box">
          <Button class="cancel" @click="visible=false">取消</Button>
          <Button type="primary" @click="ok">确认</Button>
        </div>        
      </div>
    </div>
  </Modal>
</template>

<script>
import filters from '@/api/filter';
export default {
  props:['id', 'isList', 'getInsureList'],
  data() {
    return {
      commissionDTOList:[],
      visible: false,
      failureType:[],
      form:{
        payState:2,
        serviceStateDetail:'',
        newPolicyNo:'',
        serviceContent:'',
        renewalSource:'',
        serverEndDate:'',
      },
      ruleInline:{
        newPolicyNo:[
          { required: true, message: '请填写新保单号', trigger: 'blur' }
        ],
        serverEndDate:[
          { required: true, type: 'date', message: '请选择时间', trigger: 'change' }
        ]
      },
      data:{}
    };
  },

  methods: {
    open(data) {
      this.$refs.form.resetFields();
      this.data = data;      
      this.visible = true;
    },

    // 续保方式
    changeRenew(value) {
      if(value == 1){
        this.form.newPolicyNo = this.data.policyNo;
      }else if(this.form.newPolicyNo == this.data.policyNo && value != 1) {
        this.form.newPolicyNo = '';
      }
    },

    // 选择续费状态
    changePayState(value) {
      this.$refs.form.resetFields();
      this.form = {
        payState:value,
        serviceStateDetail:'',
        newPolicyNo:'',
        serviceContent:'',
        renewalSource:''
      }
      
      if(value == 3) {
        this.failureType = [
          {
            label:'已理赔',
            value:'1'
          },
          {
            label:'已过最晚续保日',
            value:'2'
          },
          {
            label:'健康原因',
            value:'3'
          },
          {
            label:'产品原因',
            value:'4'
          },
          {
            label:'经济原因',
            value:'5'
          },
          {
            label:'已退保',
            value:'6'
          },
          {
            label:'其他',
            value:'7'
          }
        ]
      }else if(value == 1){
        this.failureType = [
          {
            label:'无法联系',
            value:'8'
          },
          {
            label:'有意向退保',
            value:'9'
          },
          {
            label:'准备续保',
            value:'10'
          },
          {
            label: '跟进完成',
            value: '13'
          },
          {
            label: '跟进终止',
            value: '14'
          },
        ]
      }
    },

    // 失败类型
    selectedFailType(item) {
      this.form.serviceStateDetail = item.value;
    },

    ok() {
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return
        }
        this.submit();
      })      
    },

    submit(){
      let data = {
        id:this.id,
        serviceState:2, //流程状态(1、待跟进 2、跟进中 3、跟进完成)
        payState:this.form.payState, //续保状态 1 待续保  2续保成功  3 续保失败
        newPolicyNo:this.form.newPolicyNo, //新单保单号
        serviceContent:this.form.serviceContent, //描述
        serviceStateDetail:this.form.serviceStateDetail, //1已理赔  2已过宽限期 3健康原因 4产品原因 5 经济原因  6 已退保 7其他 8、无法联系 9、有意向退保 10、准备续费
        renewalSource:this.form.renewalSource,//续保类型
        serverEndDate:this.form.serverEndDate?filters.filterTime(this.form.serverEndDate, 'YYYY-MM-DD'):'',//实际续保日期
      }
      this.$http({
        url: `/buz/policyShortRenewalRecord/updateRenewalRecord`,
        type: "POST",
        data,
          apiPermissionCode:'renewalManage_01_7'
      }).then((res) => {
        this.$notice.success("操作成功");
        if(this.isList){
          this.getInsureList();
        }else{
          this.$emit('updatePolicyData');
        }
        this.visible = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.follow-up-container {
  padding: 0 0 5px 10px;
  .ivu-icon-ios-help-circle-outline {
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    margin-left: 4px;
  }
  .fee-status {
    .total {
      display: flex;
      border: 1px solid #e8eaec;
      border-top: none;
      border-right: none;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.23%;
        border-right: 1px solid #e8eaec;
      }
    }
    .failure-type{
      display: flex;
      flex-wrap: wrap;
      .failure-btn {
        width: 105px;
        height: 32px;
        border-radius: 4px;
        background: #F5F7F9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3C464F;
        font-size: 14px;
        margin-bottom: 10px;
        margin-right: 10px;
      }

      .failure-btn:hover {
        cursor: pointer;
      }
      
      & .active {
        background: rgba(235,241,255,0.39);
        color: #236DFF;
        border: 1px solid #236DFF;
      }
    }
  }
}
.action-buttom {
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .buttom-box {
    width: 50%;
    display: flex;
    justify-content: center;
    justify-content: space-between;
    Button {

      width: 140px;
      height: 36px;;
    }
    .cancel {
      width: 120px;
      border-color: #236dff;
      color: #236dff;
    }
  }
  
}
</style>